import { render } from "./settings-index.vue?vue&type=template&id=8d92ab5e"
import script from "./settings-index.vue?vue&type=script&lang=js"
export * from "./settings-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__